(() => {
	angular
		.module('main')
		.controller('UnsubscribeEmailsController', UnsubscribeEmailsController);

	UnsubscribeEmailsController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http'
	];

	function UnsubscribeEmailsController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http
	) {
		const allUrlParams = $routeParams;

		$scope.$on('$viewContentLoaded', () => {
			$rootScope.signInPage = false;
			console.log('::: unsubscribeEmailsController :::');
			delete $rootScope.error;
			const restPathUrl = '/public/rest/unsubscribefromintroemails/';
			const unsubscribePathPart = 'unsubscribefromintroemails/';
			let url = $location.path();
			const index = url.indexOf(unsubscribePathPart);
			console.log(`url=$location.path()=${url}`);
			console.log(`restPathUrl=${restPathUrl}`);

			if (index && index + unsubscribePathPart.length < url.length) {
				url = url.substring(unsubscribePathPart.length + index, url.length);
				url = restPathUrl + url;
				console.log(`new url=${url}`);
			} else {
				url = null;
			}
			if (url) {
				$http
					.get(url)
					.then(result => {
						const { data, status } = result;
						console.log(`${status} unsubscribe emails status`);
						if (data) {
							console.log(data);
							if (data.success) {
								delete $rootScope.error;
								toastr.success(
									'You have been removed from this mailing list.',
									'Successfully unsubscribed!'
								);
								$location.path('/login');
							} else {
								toastr.error(
									'You have already unsubscribed from this mailing list.',
									'Oops!'
								);
								console.log(`data failed forgot : ${data}`);
								$rootScope.error = true;
								$rootScope.error_message = data.message;
							}
							console.log(data);
							$scope.userActionResult = data;
						}
					})
					.catch(result => {
						const { data, status } = result;
						toastr.error('Failed request to server', 'Error');
						console.log(`${status} confirm password status`);
						$rootScope.authenticated = false;
						$rootScope.error = true;
						$rootScope.error_message = 'Failed request to server';
					});
			}
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/unsubscribeEmailsController.js